import CelModeTab from "./general/CelModeTab";
import RawEditorTab from "./raw/RawEditorTab";
import AchievementEditorTab from "./achievements/AchievementEditorTab";

export const celmodeTabs = {
  CelModeTab,
  RawEditorTab,
  AchievementEditorTab,
};
